module.exports = __webpack_public_path__ + "img/ic-interpaycard.f1da6741.svg";